import { observer } from 'mobx-react';
import { ICONS } from "shared/constants";
import { UiIcon } from "shared/uikit";

import './styles.scss';

type PropsType = {
    isActive?: boolean;
    onClick?: () => void;
}

export const PPDWidgetBonusBadge = observer(({
    isActive = false,
    onClick,
}: PropsType) => {
    return (
        <div
            className={`ppd-widget-bonus-badge ${isActive ? 'ppd-widget-bonus-badge--active' : 'ppd-widget-bonus-badge--inactive'}`}
            onClick={onClick ?? undefined}
        >
            <div className="ppd-widget-bonus-badge__icon">
                <UiIcon icon={isActive ? ICONS.BONUS_GOLD : ICONS.BONUS_GREY} size={24} />
            </div>
            <div className="ppd-widget-bonus-badge__name">Бонусы</div>
        </div>
    );
});
